var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5208 3.5051L7.55438 4.05873L6.99479 3.99094C4.95791 3.73107 3.17843 2.84977 1.66756 1.36964L0.928908 0.635229L0.73865 1.17757C0.33575 2.38653 0.593158 3.66328 1.43253 4.52198C1.8802 4.99653 1.77948 5.06432 1.00725 4.78185C0.73865 4.69146 0.503625 4.62367 0.481242 4.65757C0.4029 4.73666 0.6715 5.76484 0.884142 6.17159C1.17513 6.73653 1.76828 7.29016 2.4174 7.61782L2.96579 7.87769L2.31668 7.88899C1.68994 7.88899 1.66756 7.90029 1.73471 8.13756C1.95854 8.87198 2.84268 9.65159 3.82755 9.99055L4.52143 10.2278L3.91708 10.5894C3.02175 11.1091 1.96973 11.4029 0.917717 11.4255C0.414092 11.4368 0 11.482 0 11.5159C0 11.6289 1.36538 12.2616 2.15999 12.5102C4.54382 13.2446 7.37531 12.9282 9.50173 11.6741C11.0126 10.7815 12.5235 9.00756 13.2286 7.29016C13.6091 6.37497 13.9896 4.70276 13.9896 3.90055C13.9896 3.38081 14.0232 3.31302 14.6499 2.69159C15.0192 2.33003 15.3662 1.93458 15.4333 1.82159C15.5452 1.60692 15.534 1.60692 14.9633 1.799C14.012 2.13796 13.8777 2.09276 14.3477 1.58432C14.6947 1.22276 15.1088 0.567437 15.1088 0.375359C15.1088 0.341463 14.9409 0.397957 14.7506 0.499645C14.5492 0.612632 14.1015 0.782112 13.7658 0.883801L13.1614 1.07588L12.613 0.703022C12.3108 0.499645 11.8856 0.273671 11.6617 0.205879C11.0909 0.0476971 10.218 0.0702945 9.70318 0.251074C8.30422 0.759515 7.42008 2.07016 7.5208 3.5051Z",
    fill: "#0EC99E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.83c696b9da0e0a2c6f3e14acd30321ea.svg";
export { ForwardRef as ReactComponent };